import {useState, useEffect} from 'react';
import './Modal.css';

export function Modal({children, active, onClose, onMount})
{
	const [stateActive, setActive] = useState(active);
	let modalElm;

	const onClick = (e) =>
	{
		if(active)
		{
			if(!onClose || onClose() !== false)
			{
				if(modalElm)
				{
					const transEnd = () =>
					{
						modalElm.removeEventListener('transitionend', transEnd);
						setActive(false);

					};
					modalElm.addEventListener('transitionend', transEnd);
					modalElm.classList.add('is-animating-out');
				}
			}
		}
	}

	const onActivate = (elm) => 
	{
		if(elm)
		{
			modalElm = elm;
			if(elm.classList.contains('is-animating-in'))
			{
				let k = elm.offsetHeight;
				elm.classList.remove('is-animating-in');
			
			}
		}
	}

	useEffect(() =>
	{
		setActive(active);

	}, [active, children]);

	return (
		stateActive && (
		<div className="modal is-active is-animating-in" ref={onActivate}>
			<div className="modal-background"></div>
			<div className="modal-content">
				{children}
			</div>
			<button onClick={onClick} className="modal-close is-large" aria-label="close"></button>
		</div> ) 
	);
}